<template>
  <v-dialog v-model="productsDialog" scrollable max-width="677px">
    <template v-slot:activator="{ on, attrs }">
      <div class="text-right mb-4">
      <v-btn
              dark
              v-bind="attrs"
              v-on="on"
      >
        Редактировать
      </v-btn>
      </div>
    </template>
    <v-card>
      <v-card-title>Добавить блюда</v-card-title>
      <v-card-text style="height: 300px;">
        <v-expansion-panels>
          <v-expansion-panel
                  v-for="productsCategory in productsCategories"
                  :key="productsCategory.id"
                  :id="productsCategory.id"
          >
            <v-expansion-panel-header>{{productsCategory.name}}</v-expansion-panel-header>
            <v-expansion-panel-content class="without-padding">
              <ul>
                  <li class="products" v-for="product in productsCategory.related_products" :class="{selected: product.selected}">
                      <v-checkbox
                        dense
                        hide-details
                        v-model="product.selected"
                        :label="product.name"
                      >
                      </v-checkbox>
                  </li>
              </ul>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card-text>
      <v-card-actions>
        <v-btn block @click="update">Добавить</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import SaleService from "../api/SaleService";

  export default {
    name: 'SaleProductsModal',
    props: {
      productsCategories: Array,
      value: Object
    },
    data() {
      return {
        productsDialog: false,
        modifierGroup: {},
        sale: this.value,
      };
    },
    methods: {
      init(item){
          this.productsDialog = true
          this.sale = item
          let _this = this
          this.productsCategories.forEach(function (category) {
              category.related_products.forEach(function (product) {
                  if(_this.sale.products.find(prod => prod.id == product.id)){
                      product.selected = true;
                  } else {
                      product.selected = false
                  }
              })
          })
      },
      clickOnRow(product){
          product.selected = !product.selected
      },
      update() {
        var _this = this;

        this.sale.products = [];
        this.productsCategories.forEach(function (category) {
          category.related_products.forEach(function (product) {
            if(product.selected){
              _this.sale.products.push(product)
            }
          })
        })

        SaleService.updateProducts(this.sale.id, this.sale.products).then(response => {
          this.sale.products = response.data.products
        });


      }
    },
    mounted() {
        var _this = this
        this.productsCategories.forEach(function (category) {
            category.related_products.forEach(function (product) {
                if(_this.sale.products.find(prod => prod.id == product.id)){
                    console.log(product.id)
                    product.selected = true
                }
            })
        })

    },
    watch: {
      product(val) {
        this.$emit('input', val);
      }
    }
  }
</script>

<style lang="scss">
  .without-border {
    .v-input__slot{
      padding: 0!important;
    }
    .v-icon{
      width: 40px;
    }
    .v-input__prepend-outer{
      margin-right: 0;
    }
    .theme--light.v-icon:focus::after {
      opacity: 0;
    }
    input{
      text-align: center;
    }
    &.v-text-field--outlined{
      fieldset {
        border: none!important;
      }
    }
  }
  .without-padding .v-expansion-panel-content__wrap{
    padding: 0;
  }
  ul{
    li{
      &.products{
        display: flex!important;
        align-items: center!important;
        .v-input{
          margin-top: 0;
          padding-top: 0;
        }
      }
    }
  }

</style>

<style lang="scss" scoped>

  ul{
    list-style-type: none;
    padding-left: 0;
    li{
      list-style-type: none;
      display: grid;
      padding: 0 28px;
      margin-bottom: 8px;
      &.products{
        display: block;
        height: 40px;
      }
      &.selected{
        background-color: #EEF8FF;
      }
      .name{
        vertical-align: top;
        line-height: 40px;
        color: #666;
        font-weight: 500;
        padding-left: 8px;
        font-size: 14px;
      }
    }
  }

</style>
